<div class="notification-container">
  <div class="notification-container__detail">
    <img [src]="content.icon.src" [alt]="content.icon.alt" />
    <div class="notification-container__detail--title">
      {{ content.details.title }}
    </div>
    <div class="notification-container__detail--desc">
      {{ content.details.subtitle }}
    </div>
  </div>
</div>
